import { applyPickupExclusivity } from '../bestBuyPickup';
import { CartPolicy } from './types';

/**
 * A cart with a Best Buy pickup ring is exclusive: see lib/commerce/cart/
 * bestBuyPickup.ts. Runs right after sizingKitBundle so maxPlanSwap,
 * duplicateLine and maxQuantity see the cart without the lines it removes
 * (cartWithoutPendingRemovals).
 */
export const bestBuyPickupExclusivePolicy: CartPolicy = (input, cart, meta) =>
  applyPickupExclusivity(
    input,
    cart ? cart.lines.edges.map((edge) => edge.node) : null,
    { store: meta.store, createNewCart: meta.createNewCart },
  );
